require("./group_nav")

class GroupManagement extends HTMLElement {
  constructor() {
    super();
  }
 
  connectedCallback() {
    this.is_admin = (this.dataset.admin == 'true');
    this.innerHTML = `
      <style>
        .navbar {
          margin-bottom: 0px;
        }

        group-management {
          margin-left: 10px;
          height: calc(100vh - 52px);
          display: block;
        }

        group-management > div {
          float: right;
          width: calc(100% - 300px);
          height: calc(100vh - 52px);
          padding-top: 20px;
          overflow: auto;
        }
        group-management .content {
          height: calc( 100% - 30px);
          width: 100%;
          border: none;
        }

        group-management #group_nav_breadcrumb_pills {
          margin-left: 25px;
        }

        group-management #group_nav_breadcrumb_pills group-nav-breadcrumb {
          margin-right: 10px;
          cursor: pointer;
        }

        group-management.full_screen group-nav {
          display:none;
        }

        group-management.full_screen > div {
          width: 100%;
        }

        group-management #group_management_body.loading #group_management_loading {
          display: block;
        } 

        group-management #group_management_body.loading .content {
          display: none;
        } 
      </style>
      <group-nav ${this.is_admin ? 'data-is_admin=true' : ''}></group-nav>
      <div id="group_management_body">
        <div id="group_nav_breadcrumb_pills"></div>
        <div class="content"><groups-splash-screen></groups-splash-screen></div>
        <div id="group_management_loading" style="display: none;">Loading...</div>
      </div>
    `;
  }

  hideNav() {
    this.classList.add("full_screen");
  }

  showNav() {
    this.classList.remove("full_screen");
  }
}

customElements.define('group-management', GroupManagement)